import React, { useState } from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import HelpSvg from 'images/icons/fc-marketing/help.svg'
import Dialog from 'components/program-marketing/dialog'

const useStyles = makeStyles(theme => ({
  childCard: {
    width: '100%',
    boxShadow: 'none',
    border: '1px solid #DBDCDD',
    boxSizing: 'border-box',
    borderRadius: '10px',
    padding: '14px',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: '21px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(-1),
  },
}))

const ChildCardLabel = ({ gray, children }) => (
  <Typography
    color="secondary"
    style={{ color: gray ? '#95969A' : null, display: 'inline-block' }}
    variant="h6"
    align="left"
  >
    {children}
  </Typography>
)

export default function Landing({
  onlineFee,
  offlineFee,
  hideIfApplicable = false,
}) {
  const classes = useStyles()
  const [dialogOpen, setDialogOpen] = useState(false)

  const openDialog = () => setDialogOpen(true)
  const closeDialog = () => setDialogOpen(false)

  return (
    <>
      <Box className={classes.childCard} onClick={openDialog}>
        <Box
          m={0.5}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <ChildCardLabel>${onlineFee}</ChildCardLabel>
          <ChildCardLabel gray>${offlineFee}</ChildCardLabel>
        </Box>
        <Box
          m={0.5}
          flexGrow={1}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
        >
          <ChildCardLabel>
            Online Payment {!hideIfApplicable && '(if applicable)'}
          </ChildCardLabel>
          <ChildCardLabel gray>Offline Payment</ChildCardLabel>
        </Box>
        <Box display="flex" alignItems="center" mr={1}>
          <img src={HelpSvg} alt="fee-help" />
        </Box>
      </Box>

      <Dialog
        heading="Online and Offline Payments"
        open={dialogOpen}
        onClose={closeDialog}
        text="'Online Payment' is the amount due at registration checkout. 'Offline Payment' fees are paid directly to your PGA Coach at a later date."
      />
    </>
  )
}
